import { GlobalStyles } from '@service-victoria/component-library/utils/globalStyles';
import * as React from 'react';
// import { Helmet } from 'react-helmet';
// import { BrowserRouter as Router, Route } from 'react-router-dom';
// import { QueryParamProvider } from 'use-query-params';
import { BrowserRouter as Router } from 'react-router-dom';
import { StateInspector } from 'reinspect';
import styled, { ThemeProvider } from 'styled-components';

import Routes from 'routes';
import { themes } from 'utils';

export type ComponentProps = Record<string, unknown>;

// const cspContent = `${process.env.REACT_APP_CSP_CONTENT ?? ''} '${constants.nonce}'`;

const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
`;

const App: React.FC<ComponentProps> = () => {
  // load the previous saved context if there was any
  return (
    <Wrapper>
      <ThemeProvider theme={themes.primary}>
        <GlobalStyles />
        {/* {process.env.NODE_ENV === 'production' && (
          <Helmet>
            <meta httpEquiv='Content-Security-Policy' content={cspContent} />
          </Helmet>
        )} */}
        <StateInspector name='App'>
          <Router basename={process.env.PUBLIC_URL}>
            <Routes />
          </Router>
        </StateInspector>
      </ThemeProvider>
    </Wrapper>
  );
};
export default App;
